import { theme } from 'styles/theme/hav-theme'

export const statusBgs = {
  ABERTO: theme.colors.alert.warning.dark,
  ANÁLISE: theme.colors.alert.info.dark,
  CANCELADO: theme.colors.neutral.light,
  CONCLUIDO: theme.colors.alert.success.dark,
  'EM APROVAÇÃO': theme.colors.alert.warning.dark,
  'EM REMESSA': theme.colors.support.fourth,
  'EM RESERVA': theme.colors.support.third,
  'ENVIADO AO SAP': theme.colors.support.second,
  FATURADO: theme.colors.alert.success.darker,
  FATURAMENTO: theme.colors.support.first,
  PENDENTE: theme.colors.alert.danger.dark,
  PROCESSANDO: theme.colors.alert.info.dark,
  RESTRITO: theme.colors.alert.danger.dark,
}

export type statusBgKey = keyof typeof statusBgs
